import { render, staticRenderFns } from "./GestionnaireHome.vue?vue&type=template&id=35b5a1c0&scoped=true&"
import script from "./GestionnaireHome.vue?vue&type=script&lang=js&"
export * from "./GestionnaireHome.vue?vue&type=script&lang=js&"
import style0 from "./GestionnaireHome.vue?vue&type=style&index=0&id=35b5a1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b5a1c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
